<template>
  <!-- 5-7 医疗机构信息认证信息修改提示 审核成功 -->
  <div class="main-box">
    <!--    标题-->
    <div class="box-main-big-css">
      <!-- -----------------------------------------白色导航条----------------------------------------- -->
      <div class="index-top">
        <!-- 左侧logo语言切换 -->
        <div class="logo">
          <div><img src="./assets/Logo Shapes 42.png" alt="" /></div>
          <p class="logo-title">{{ $t('easyCareer') }}</p>
          <!-- 语言切换 -->

        </div>
      </div>
    </div>
    <!-- 弹窗的操作部分 -->
    <div class="im-box">

      <div class="div-1">
        <div class="row">
          <img src="./assets/loadin.gif" alt="" />
        </div>
      </div>

      <!--          内容-->
      <div class=" div-2">
        <div class="div-2-main">
          <p>{{ $t('validatingRegistrationCode') }}</p>
        </div>
      </div>

      <!--          按钮-->
      <div class=" div-3">
        <!--        <a href="#" class="button">{{$t('close')}}</a>-->
      </div>
    </div>

    <div class="footer-main">
      <div class="year-css">2022 © rakurakucarrer</div>
      <span>Puchase</span>
      <span>Support</span>
      <span>About</span>
    </div>

  </div>
</template>
<script>
import { registerVerifyEmail } from "../../js/api"
export default {
  name: "Institutional",
  components: {},
  data() {
    return {
      token: ""
    };
  },
  created() {
    console.log("---------------url参数---------------")
    console.log(window.location.href)
    var urlToken = window.location.href
    var urlString = urlToken.split("token=")
    this.token = urlString[1]
    console.log("测试是否能有效的获取到token")
    console.log(this.token)
    this.registerEmailSet();
  },
  computed: {},
  methods: {
    registerEmailSet() {
      var that = this
      var fakeInfo = {
        token: this.token
      }
      registerVerifyEmail(fakeInfo).then((res) => {
        console.log("---------------邮箱验证---------------")
        console.log(res)
        if (res.data.code === "A0000") {
          that.$message({
            message: '验证成功',
            type: 'success'
          });
          that.$router.push("/login");
        }else {
          that.$message.error('验证失败，请重新验证');
        }
      }).catch((res) => {
        console.log("---------------邮箱验证---------------")
        console.log(res)
      })
    }
  },
};
</script>
<style scoped>
.pages-css {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}

.main-box {
  width: 100%;
  height: 100%;

}

.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #6b5656;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 4;
  /*行间距*/
  margin-top: 20px;

}

.im-box {
  width: 498px;
  height: 266px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin: auto;
  margin-top: 12%;

}

.div-1 {
  width: 100%;
  height: 90px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80px
}

.row {
  width: 50px;
  height: 50px;
  text-align: center;
  /* 第二主色 */
  background: #51ABFF;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: courier, "courier new", monospace;
  /*字体*/
  color: #FFFFFF;
  /*字体颜色*/
  font-size: 55px;
  /*字体大小*/
  margin-top: 40px
}

.div-2 {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px
}

.div-2-main {
  width: 280px;
  height: 48px;
  /* 表头样式 */
  font-family: 'Open Sans';
  text-align: center;
  /*对齐方式*/
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  /* 灰色字体 */
  color: #686868;

}

.div-3 {

  width: 100%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;

}

.button {
  color: #51ABFF;
  padding: 0px 19px;
  border: 1px solid #51ABFF;
  order: 0;
  flex-grow: 0;
  margin: 0px 10px;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
}

.box-main-big-css {
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;

}

.index-top {
  padding: 16px 35px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}

.logo {
  width: 250px;
  display: flex;
}

.logo-title {
  font-family: "Mochiy Pop One";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #686868;
  margin: 0 5px;
}

.footer-main {
  margin-top: 18%;
  width: 95%;
  margin-left: 2.5%;
  background: #fff;
  height: 60px;
  line-height: 60px;
  border-top: 1px solid #e0e1ea;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  align-items: center;
  letter-spacing: -0.02em;
  color: #c9cfda;

}

.footer-main span {
  float: right;
  margin-right: 20px;
  cursor: pointer;
}

.year-css {
  float: left;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/transitBearer/index.vue